const THEME_KEY = 'theme-preference';

function getStoredTheme() {
  return localStorage.getItem(THEME_KEY);
}

function storeTheme(theme) {
  localStorage.setItem(THEME_KEY, theme);
}

function applyTailwindTheme(theme) {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

function detectPreferredScheme() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

function ensurePrimeVueThemeLink() {
  let link = document.getElementById('primevue-theme');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = 'primevue-theme';
    document.head.appendChild(link);
  }
  return link;
}

function applyPrimeVueTheme(theme) {
  const link = ensurePrimeVueThemeLink();
  // Use a dark and a light theme from PrimeVue resources
  const darkHref = 'https://unpkg.com/primevue@3.29.2/resources/themes/arya-blue/theme.css';
  const lightHref = 'https://unpkg.com/primevue@3.29.2/resources/themes/saga-blue/theme.css';
  link.href = theme === 'dark' ? darkHref : lightHref;
}

export function initTheme() {
  const stored = getStoredTheme();
  const theme = stored || detectPreferredScheme();
  applyTailwindTheme(theme);
  applyPrimeVueTheme(theme);
  return theme;
}

export function setTheme(theme) {
  storeTheme(theme);
  applyTailwindTheme(theme);
  applyPrimeVueTheme(theme);
}

export function toggleTheme() {
  const current = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
  const next = current === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}
